// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import axios from 'axios'
import viser from 'viser-vue'
import './utils/Date'

import iView from 'view-design'
// import style
import 'view-design/dist/styles/iview.css'
import './assets/index.less'
import './components/Base/index'
import VueClipboard from 'vue-clipboard2'
import ExpandTable from '@/pages/taskManage/detail/ExpandTable'
import EventBus from '@/utils/event'

Vue.use(iView)
Vue.use(viser)
Vue.use(VueClipboard)
axios.defaults.baseURL =
  process.env.NODE_ENV === 'production' ? '/bo/' : '/dev/bo/'
// 请求过滤器
axios.interceptors.request.use((config) => {
  if (config.method !== 'get') {
    let ctoken = store.state.user.user.csrfToken
    if (
      config.method === 'post' ||
      config.method === 'put' ||
      config.method === 'patch'
    ) {
      // 判断参数是否经过stringify转换
      if (typeof config.data === 'object') {
        config.data.ctoken = ctoken
      } else {
        if (config.data) {
          config.data += '&ctoken=' + ctoken
        } else {
          config.data = 'ctoken=' + ctoken
        }
      }
    } else if (config.method === 'delete') {
      if (config.url.indexOf('?') === -1) {
        config.url += '?ctoken=' + ctoken
      } else {
        config.url += '&ctoken=' + ctoken
      }
    }
  }
  return config
})
// 响应过滤器
axios.interceptors.response.use(
  (res) => {
    switch (res.status) {
      case 200:
        let data = res.data
        if (!data.success && data.message === '未登录') {
          router.push({
            name: 'Login',
          })
        }
        return data
    }
  },
  (err) => {
    switch (err.response.status) {
      case 404:
        // iView.Message.error('404 err')
        router.push({
          name: 'Login',
        })
        break
      case 500:
        iView.Message.error('500 err')
        break
      default:
        iView.Message.error('unknow err')
    }
    return Promise.reject(err)
  }
)
Vue.prototype.$http = axios
Vue.prototype.$qs = require('querystring').stringify
Vue.prototype.$header = {
  'Content-Type': 'application/json;charset=utf-8',
}
Vue.config.productionTip = false

// RouterName menu/list
Vue.prototype.AddTag = (RouterName) => {
  let thirdMenuList = store.state.menu.thirdMenuList
  for (var val in thirdMenuList) {
    thirdMenuList[val].forEach((item, index) => {
      if (item.routerName === RouterName) {
        store.dispatch('menu/_AddTag', item.parent_id + '-' + item.id)
      }
    })
  }
}

/* eslint-disable no-extend-native */
Date.prototype.Format = function (fmt = 'yyyy-MM-dd hh:mm:ss') {
  var o = {
    'M+': this.getMonth() + 1,
    'd+': this.getDate(),
    'h+': this.getHours(),
    'm+': this.getMinutes(),
    's+': this.getSeconds(),
    'q+': Math.floor((this.getMonth() + 3) / 3),
    S: this.getMilliseconds(),
  }
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(
      RegExp.$1,
      (this.getFullYear() + '').substr(4 - RegExp.$1.length)
    )
  }
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length)
      )
    }
  }
  return fmt
}
Vue.component('ExpandTable', ExpandTable)

Vue.use(EventBus)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: {
    App,
  },
})



// WEBPACK FOOTER //
// ./src/main.js